import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
// Third party packages
import { MatDialog, MatDialogRef } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { ActivationsService } from "src/app/modules/settings/activations.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
/**
 * Script start
 */
var ActivationEditDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function ActivationEditDialogComponent(dialogRef, data, dialog, configService, translateService, authService, cookieService, toastrService, helperService, settingsService, activationsService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.dialog = dialog;
        this.configService = configService;
        this.translateService = translateService;
        this.authService = authService;
        this.cookieService = cookieService;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.settingsService = settingsService;
        this.activationsService = activationsService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.dialogIsLoading = true; // Used to view/hide form loading spinner
        this.title = "";
        // BEGIN - Edit item form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.docForm = new FormGroup({});
        this.model = {};
        this.docModel = {};
        this.fields = [];
        this.docFields = [];
        this.options = {};
        this.docOptions = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
        // END - Edit item form
        this.documents = [];
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    ActivationEditDialogComponent.prototype.ngOnInit = function () {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d, e_5, _e;
        if (this.data.new) {
            this.title = 'Nuova attivazione';
        }
        else {
            this.title = 'Modifica attivazione';
        }
        var documents = [];
        if (this.data.documentTemplate &&
            Array.isArray(this.data.documentTemplate)) {
            try {
                for (var _f = tslib_1.__values(this.data.documentTemplate), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var contents = _g.value;
                    if (contents &&
                        contents.content &&
                        Array.isArray(contents.content)) {
                        try {
                            for (var _h = (e_2 = void 0, tslib_1.__values(contents.content)), _j = _h.next(); !_j.done; _j = _h.next()) {
                                var docs = _j.value;
                                var title = docs.title.replace('properties.documents.', '');
                                var translationTitle = docs.translation && docs.translation.it ? docs.translation.it : '';
                                if (docs.documents && Array.isArray(docs.documents)) {
                                    try {
                                        for (var _k = (e_3 = void 0, tslib_1.__values(docs.documents)), _l = _k.next(); !_l.done; _l = _k.next()) {
                                            var doc = _l.value;
                                            var translationKey = doc.translation && doc.translation.it ? doc.translation.it : '';
                                            this.documents.push({
                                                value: title + "#-#" + doc.key,
                                                label: translationTitle + ": " + translationKey,
                                            });
                                        }
                                    }
                                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                    finally {
                                        try {
                                            if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                                        }
                                        finally { if (e_3) throw e_3.error; }
                                    }
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var params = [];
        var options = [];
        options.push({
            value: '',
            label: '--- Seleziona un valore ---',
        });
        if (this.data.fieldGroup &&
            Array.isArray(this.data.fieldGroup)) {
            try {
                for (var _m = tslib_1.__values(this.data.fieldGroup), _o = _m.next(); !_o.done; _o = _m.next()) {
                    var item = _o.value;
                    if (item.key !== 'note') {
                        if (item.templateOptions &&
                            item.templateOptions.options &&
                            Array.isArray(item.templateOptions.options)) {
                            try {
                                for (var _p = (e_5 = void 0, tslib_1.__values(item.templateOptions.options)), _q = _p.next(); !_q.done; _q = _p.next()) {
                                    var option = _q.value;
                                    options.push({
                                        value: option.value,
                                        label: option.translation.it
                                    });
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                        }
                        if (item.templateOptions &&
                            item.templateOptions.translationLabel &&
                            item.templateOptions.translationLabel.it) {
                            params.push({
                                value: item.key,
                                label: item.templateOptions.translationLabel.it
                            });
                        }
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        this.initForm(params, options);
    };
    /**
     * Get docuemnts
     *
     * @since 1.0.0
     */
    ActivationEditDialogComponent.prototype.getDocuments = function (start, limit, sort, sortVersus, search) {
        // this.documents;
        return new Observable(function (obs) {
            return obs.next({ value: '1', label: 'ciao' });
        });
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    ActivationEditDialogComponent.prototype.initForm = function (params, options) {
        if (this.data.new) {
            this.fields = [];
            this.model = [];
            this.docFields = [];
            this.docModel = [];
        }
        else {
            this.data.activations.fields.forEach(function (el) {
                el.option = el.value;
            });
            this.fields = [];
            this.model.structure = this.data.activations.fields;
            this.docFields = [];
            var initDocs_1 = [];
            this.data.activations.docs.forEach(function (el) {
                el.keys.forEach(function (subEl) {
                    initDocs_1.push({
                        name: {
                            value: el.name + "#-#" + subEl,
                            label: el.name + "#-#" + subEl,
                        },
                    });
                });
            });
            this.docModel.documents = initDocs_1;
        }
        this.fields = [
            {
                key: 'structure',
                type: 'repeat-structure-options',
                templateOptions: {
                    addText: 'Aggiungi una nuova relazione',
                },
                fieldArray: {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                        {
                            className: "col-3",
                            type: "select",
                            key: "name",
                            templateOptions: {
                                label: "Parametro",
                                placeholder: "Parametro",
                                required: true,
                                multiple: false,
                                options: params,
                            },
                        },
                        {
                            className: "col-1",
                            type: "select",
                            key: "operation",
                            templateOptions: {
                                label: "Operazione",
                                placeholder: "Operazione",
                                required: true,
                                multiple: false,
                                options: [
                                    {
                                        value: "<",
                                        label: "<",
                                    },
                                    {
                                        value: "<=",
                                        label: "<=",
                                    },
                                    {
                                        value: "=",
                                        label: "=",
                                    },
                                    {
                                        value: ">",
                                        label: ">",
                                    },
                                    {
                                        value: ">=",
                                        label: ">=",
                                    },
                                ],
                            },
                        },
                        {
                            className: "col-3",
                            type: "select",
                            key: "option",
                            templateOptions: {
                                label: "Opzioni",
                                placeholder: "Opzioni",
                                required: false,
                                multiple: false,
                                options: options,
                            },
                        },
                        {
                            className: "col-2",
                            type: "input",
                            key: "value",
                            templateOptions: {
                                label: "Valore",
                                placeholder: "Valore",
                                required: false,
                                minLength: 2,
                                maxLength: 500,
                            },
                            defaultValue: "",
                        },
                    ],
                },
            },
        ];
        this.docFields = [
            {
                key: 'documents',
                type: 'repeat-structure-options',
                templateOptions: {
                    addText: 'Aggiungi un documento',
                },
                fieldArray: {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                        {
                            className: "col-12",
                            type: "autocomplete",
                            key: "name",
                            templateOptions: {
                                label: "Nome del documento da attivare",
                                placeholder: "Nome del documento da attivare",
                                required: true,
                                // multiple: false,
                                // options: documents,
                                bindLabel: "label",
                                bindValue: "value",
                                // initialValues: [this.docModel.documents.name],
                                multiple: false,
                                search$: this.getDocuments.bind(this),
                                typeToSearchText: this.translateService.instant("common.words.typeToSearch", { minTermLength: 1 }),
                                clearAllText: this.translateService.instant("common.words.clearAll"),
                                notFoundText: this.translateService.instant("common.words.notFound"),
                                loadingText: this.translateService.instant("common.words.loading"),
                            },
                        },
                    ],
                },
            },
        ];
        this.dialogIsLoading = false;
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    ActivationEditDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle dialog denial
     *
     * @since 1.0.0
     */
    ActivationEditDialogComponent.prototype.onSave = function () {
        var e_6, _a, e_7, _b;
        var _this = this;
        if (!this.model.structure ||
            !Array.isArray(this.model.structure) ||
            !this.model.structure.length ||
            !this.docModel.documents ||
            !Array.isArray(this.docModel.documents) ||
            !this.docModel.documents.length) {
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            return;
        }
        var structures = [];
        try {
            for (var _c = tslib_1.__values(this.model.structure), _d = _c.next(); !_d.done; _d = _c.next()) {
                var structure = _d.value;
                var value = structure.value;
                if (structure.option !== '') {
                    value = structure.option;
                }
                structures.push({
                    name: structure.name,
                    operation: structure.operation,
                    value: value,
                });
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_6) throw e_6.error; }
        }
        var docs = [];
        var _loop_1 = function (doc) {
            var docKey = doc.name.split('#-#');
            var index = docs.findIndex(function (el) { return el.name === docKey[0]; });
            if (index > -1) {
                docs[index].key.push({
                    name: docKey[1]
                });
            }
            else {
                docs.push({
                    name: docKey[0],
                    key: [
                        {
                            name: docKey[1],
                        }
                    ],
                });
            }
        };
        try {
            for (var _e = tslib_1.__values(this.docModel.documents), _f = _e.next(); !_f.done; _f = _e.next()) {
                var doc = _f.value;
                _loop_1(doc);
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_7) throw e_7.error; }
        }
        var newActivation = {
            structure: this.data.structure,
            relation: "AND",
            fields: structures,
            docs: docs,
        };
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant('settings.activation.dialog.create.title'),
                message: this.translateService.instant('settings.activation.dialog.create.message'),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant('common.cta.close'),
            },
            width: '500px',
            disableClose: true
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (res) {
                if (_this.data.new) {
                    _this.activationsService.create(newActivation)
                        .subscribe(function (res) {
                        if (res.status) {
                        }
                        _this.dialogIsLoading = false;
                        _this.toastrService.success(res.message);
                    }, function (err) {
                        _this.helperService.handleError(err);
                        _this.dialogIsLoading = false;
                    });
                    _this.dialogRef.close(true);
                }
                else {
                    _this.activationsService.update(_this.data.id, newActivation)
                        .subscribe(function (res) {
                        if (res.status) {
                        }
                        _this.dialogIsLoading = false;
                        _this.toastrService.success(res.message);
                    }, function (err) {
                        _this.helperService.handleError(err);
                        _this.dialogIsLoading = false;
                    });
                    _this.dialogRef.close(true);
                }
            }
        });
    };
    /**
     * Handle dialog denial
     *
     * @since 1.0.0
     */
    ActivationEditDialogComponent.prototype.onClose = function () {
        this.dialogRef.close(false);
    };
    return ActivationEditDialogComponent;
}());
export { ActivationEditDialogComponent };
